import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import AllArtifacts from "features/memberPortal/trainingCenter/pages/AllArtifacts/AllArtifacts.screen";
import Evaluation from "features/memberPortal/trainingCenter/pages/Evaluation";
import EvaluationStatus from "features/memberPortal/trainingCenter/pages/EvaluationStatus/EvaluationStatus.screen";
import Glossary from "features/memberPortal/trainingCenter/pages/Glossary/Glossary.screen";
import PreEvaluation from "features/memberPortal/trainingCenter/pages/PreEvaluation";
import ProgressPointsReference from "features/memberPortal/trainingCenter/pages/ProgressPoints/ProgressPoints.screen";
import References from "features/memberPortal/trainingCenter/pages/References/References.screen";
import TrainingHome from "features/memberPortal/trainingCenter/TrainingHome";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { NIAP, VALIDATOR, VENDOR, LAB } = AUTH_ROLES;

const trainingRoutes: RouteObject[] = [
  {
    path: "training-center",
    element: (
      <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, VENDOR, LAB]} />
    ),
    children: [
      {
        index: true,
        element: <TrainingHome />,
      },
      {
        path: "glossary",

        element: (
          <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, LAB, VENDOR]} />
        ),
        children: [
          {
            index: true,
            element: <Glossary />,
          },
        ],
      },
      {
        path: "all-artifacts",
        element: <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, LAB]} />,
        children: [
          {
            index: true,
            element: <AllArtifacts />,
          },
        ],
      },
      {
        path: "references",
        element: <AuthenticatedRoute allowedRoles={[NIAP]} />,
        children: [
          {
            index: true,
            element: <References />,
          },
        ],
      },
      {
        path: "p1-pre-evaluation",
        element: <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, LAB]} />,
        children: [
          {
            index: true,
            element: <PreEvaluation />,
          },
        ],
      },
      {
        path: "p2-evaluation",
        element: <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, LAB]} />,
        children: [
          {
            index: true,
            element: <Evaluation />,
          },
        ],
      },
      {
        path: "progress-points-reference",
        element: <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, LAB]} />,
        children: [
          {
            index: true,
            element: <ProgressPointsReference />,
          },
        ],
      },
      {
        path: "evaluation-status-reference",
        element: <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR, LAB]} />,
        children: [
          {
            index: true,
            element: <EvaluationStatus />,
          },
        ],
      },
    ],
  },
];

export default trainingRoutes;
